//@ts-check

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ReactSortable } from 'react-sortablejs';
import stylesCourse from 'styles/Course.module.scss';
import styles from 'styles/Unit.module.scss';
import FormatContent from 'modules/Course/Unit/components/FormatContent';
import FormatContentArrow from 'modules/Course/Unit/components/FormatContentArrow';
import { parseHtml } from 'helpers';
import useWindowSize from 'hooks/useWindowSize';

const DragAndDrop = ({ value, onChange, questions, readOnly }) => {
  const QuesRef = useRef(null);
  const AnsRef = useRef(null);
  const [width] = useWindowSize();
  const [listHeight, setListHeight] = useState({
    listQus: [],
    listAns: [],
    commonHeight: [],
  });

  useEffect(() => {
    if (listHeight?.commonHeight?.length === 0) {
      return null;
    } else {
      if (questions?.length) {
        const newArray = questions?.map((item, index) =>
          listHeight.listAns?.filter(
            (inItem, inIndex) => inItem?.content === item?.content,
          ),
        );
        const filterHeight = newArray?.map(
          (item, index) => item?.length && item[0],
        );
        filterHeight?.length &&
          setListHeight((preVal) => ({
            ...preVal,
            listAns: [...filterHeight],
          }));
      }
    }
  }, [questions]);

  // get ques element height
  useEffect(() => {
    if (!QuesRef?.current) {
      return null;
    } else {
      const calculateHeights = () => {
        const newArray = Array.from(QuesRef.current.children).map(
          (item, index) =>
            item?.firstElementChild?.firstElementChild?.clientHeight,
        );
        newArray?.length &&
          setListHeight((preVal) => ({
            ...preVal,
            listQus: [...newArray],
          }));
      };
      const images = document.querySelectorAll('img');
      let loadedImagesCount = 0;

      const handleImageLoad = () => {
        loadedImagesCount += 1;
        if (loadedImagesCount === images.length) {
          calculateHeights();
        }
      };
      images.forEach((img) => {
        if (img.complete) {
          handleImageLoad();
        } else {
          img.addEventListener('load', handleImageLoad);
        }
      });

      // Cleanup event listeners
      return () => {
        images.forEach((img) => {
          img.removeEventListener('load', handleImageLoad);
        });
      };
    }
  }, [QuesRef?.current, width]);

  //  get  ans element height
  useEffect(() => {
    if (!AnsRef?.current) {
      return null;
    } else {
      if (value?.length) {
        const calculateHeights = () => {
          const newArray = Array.from(
            AnsRef?.current?.ref?.current.children,
          ).map((item, index) => ({
            content: value[index]?.content,
            height:
              item.firstElementChild?.firstElementChild?.firstElementChild
                ?.clientHeight,
            id: index,
          }));
          newArray?.length &&
            setListHeight((preVal) => ({
              ...preVal,
              listAns: [...newArray],
            }));
        };
        const images = document.querySelectorAll('img');
        let loadedImagesCount = 0;

        const handleImageLoad = () => {
          loadedImagesCount += 1;
          if (loadedImagesCount === images.length) {
            calculateHeights();
          }
        };
        images.forEach((img) => {
          if (img.complete) {
            handleImageLoad();
          } else {
            img.addEventListener('load', handleImageLoad);
          }
        });

        // Cleanup event listeners
        return () => {
          images.forEach((img) => {
            img.removeEventListener('load', handleImageLoad);
          });
        };
      }
    }
  }, [AnsRef?.current, width]);

  //  get common height from correct{qus, ans}
  useEffect(() => {
    if (listHeight.listAns.length === 0 && listHeight.listQus.length === 0) {
      return null;
    } else {
      const filterHeight = listHeight.listAns.map((item, index) =>
        listHeight.listQus[index] >= (item?.height ?? 0)
          ? listHeight.listQus[index]
          : item.height ?? 0,
      );
      filterHeight?.length &&
        setListHeight((preVal) => ({
          ...preVal,
          commonHeight: [...filterHeight],
        }));
    }
  }, [listHeight.listQus, listHeight.listAns]);

  useEffect(() => {}, [width]);
  const ContentExplanation = questions?.filter(
    (inItem) => inItem?.explanation !== '',
  );
  return (
    <div
      className={`${ContentExplanation?.length ? 'pr-2' : ''} ${
        styles.dragDropGroup
      }`}
    >
      <div ref={QuesRef}>
        <FormatContent
          list={questions}
          commonHeight={listHeight.commonHeight}
        />
      </div>
      <div>
        <FormatContentArrow
          index={questions.length}
          commonHeight={listHeight.commonHeight}
        />
      </div>
      <ReactSortable
        ref={AnsRef}
        list={value}
        swap
        animation={220}
        forceFallback
        easing="cubic-bezier(1, 0, 0, 1)"
        selectedClass={stylesCourse['item-section-selected']}
        disabled={readOnly}
        setList={(newState) => {
          onChange(newState);
        }}
      >
        {value?.length > 0 &&
          value?.map((item, index) => (
            <div>
              <div key={index}>
                <div
                  className={
                    `col position-relativecursor-pointer flexRow px-md-2 px-05 py-05 ${stylesCourse['item-section-normal']} user-select-none` +
                    ` ${stylesCourse['item-section-enabled']}` +
                    ` ${stylesCourse['animation-height']}`
                  }
                  style={{
                    maxWidth: '30rem',
                    height: listHeight.commonHeight[index],
                    '--labelcolor': '#c1c9d4',
                  }}
                >
                  <span className={`w-100 ${stylesCourse['item-unit-label']}`}>
                    <span
                      className={`drag-overflow-image ${stylesCourse['item-unit-title']}`}
                    >
                      {parseHtml(item?.content)}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          ))}
      </ReactSortable>
    </div>
  );
};

DragAndDrop.propTypes = {
  list: PropTypes.array.isRequired,
  setList: PropTypes.func.isRequired,
};

export default DragAndDrop;
